import { Risk_Assessment_Result_Control_Type_Enum } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { Ref } from 'react';

import type { WidgetRef } from '../../types';
import { EnterpriseRiskHeatmap } from './EnterpriseRiskHeatmap';

export const InherentEnterpriseRiskHeatmap = (
  _props: unknown,
  ref: Ref<WidgetRef>
) => {
  return (
    <EnterpriseRiskHeatmap
      ref={ref}
      controlType={Risk_Assessment_Result_Control_Type_Enum.Uncontrolled}
    />
  );
};
